<ion-list>

    <ion-item *ngFor="let item of items" [hidden]="!item.show" button (click)="dismiss(item.dismissCode)" lines="none">
        <ion-label>
            <span> {{ item.label | translate }}</span>
            <ion-text color="gray" class="ion-text-wrap">
                <p>{{ item.note }}</p>
            </ion-text>
        </ion-label>
        <ion-icon [color]="item.iconColor" slot="start" [name]="item.iconName"></ion-icon>
    </ion-item>

    <!-- <ion-item *ngIf="isOwner && isIta()" button (click)="dismiss('submit-score')" lines="none">
        <ion-label {{ 'Submit score to ITA' | translate }}</ion-label>
        <ion-icon slot="start" color="secondary" slot="start" name="send"></ion-icon>
    </ion-item> -->
</ion-list>